import { encryptAesGcm } from "./crypto_aes";
import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE, SECRET_KEY } from "../config/vars";

export async function fetchClient() {
    const res = await apiFetch(`${API_BASE}/clients/client`);
    if (!res.ok) throw new Error("Не вдалося завантажити дані клієнта");
    return res.json();
}

export async function updateClient(data) {
    const payload = { ...data };
    // Encrypt passwords if present
    if ((payload.current_password || payload.new_password) && !SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }
    if (payload.current_password) {
        payload.current_password = await encryptAesGcm(SECRET_KEY, payload.current_password);
    }
    if (payload.new_password) {
        payload.new_password = await encryptAesGcm(SECRET_KEY, payload.new_password);
    }

    const res = await apiFetch(`${API_BASE}/clients/client`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося оновити профіль");
    }
    return res.json();
}

export async function deleteClient() {
    const res = await apiFetch(`${API_BASE}/clients/client`, {
        method: "DELETE",
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося видалити акаунт");
    }
    return res.json();
}

export async function acceptClientTerms() {
    const res = await apiFetch(`${API_BASE}/clients/client/accept-terms`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося підтвердити умови використання");
    }
    return res.json();
}

export async function fetchClientAccessOverview() {
    const res = await apiFetch(`${API_BASE}/clients/client/access-overview`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити доступи клієнта");
    }
    return res.json();
}

export async function resolveClientAccessInvite(inviteCode) {
    const res = await apiFetch(`${API_BASE}/clients/client/access-invites/resolve`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ invite_code: inviteCode }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося перевірити інвайт-код");
    }
    return res.json();
}

export async function createClientAccessRequest(data) {
    const res = await apiFetch(`${API_BASE}/clients/client/access-requests`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося створити запит на підключення");
    }
    return res.json();
}

export async function sendClientAccessRequestMessage(requestId, body) {
    const res = await apiFetch(`${API_BASE}/clients/client/access-requests/${encodeURIComponent(requestId)}/messages`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ body }),
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося надіслати коментар");
    }
    return res.json();
}

export async function disconnectClientAccessNetwork(networkId) {
    const res = await apiFetch(`${API_BASE}/clients/client/access-networks/${encodeURIComponent(networkId)}/disconnect-request`, {
        method: "POST",
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося створити запит на відключення мережі");
    }
    return res.json();
}

export async function dismissRemovedNetworkBanner() {
    const res = await apiFetch(`${API_BASE}/clients/client/access-overview/dismiss-removed-banner`, {
        method: "POST",
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося приховати повідомлення");
    }
    return res.json();
}
